/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Loading_HintInputs */



/**
* | output |
* | --- |
* | "Loading leagues from local storage." |
*
* @param {League_Loading_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_loading_hint = /** @type {((inputs?: League_Loading_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Loading_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des ligues depuis le stockage local.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando ligas desde el almacenamiento local.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Carregando ligas do armazenamento local.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento campionati dallo storage locale.")
	return /** @type {LocalizedString} */ ("Loading leagues from local storage.")
});